import { t } from "i18next";
import { RoutineData } from "../to-be-removed/LocalData/Routines/RoutineData";

export const getLabelForMultipleSelected = (field: string) => {
  return t("main.fileActionsLabel", { field });
};

export const getRoutineActionsLabels = (isMultipleSelected: boolean) =>
  isMultipleSelected
    ? {
        title: getLabelForMultipleSelected(t("main.title").toLowerCase()),
        description: getLabelForMultipleSelected(t("main.description").toLowerCase()),
        priority: getLabelForMultipleSelected(t("main.priority").toLowerCase()),
        tags: getLabelForMultipleSelected(t("main.tags").toLowerCase()),
        properties: getLabelForMultipleSelected(t("main.properties").toLowerCase()),
        contractorGroups: getLabelForMultipleSelected(t("main.contractorGroups").toLowerCase()),
      }
    : {
        title: "",
        description: "",
        priority: "",
        tags: "",
        properties: "",
        contractorGroups: "",
      };

export const getRoutineActionsValues = (routine: RoutineData, isMultipleSelected: boolean) =>
  isMultipleSelected
    ? {
        title: "",
        description: "",
        priority: null,
        tags: [],
        properties: [],
        contractorGroups: [],
        createDaysBefore: 30,
      }
    : {
        title: routine.title,
        description: routine.description,
        priority: routine.priority,
        tags: routine.tags,
        properties: routine.properties.map(({ data }) => data),
        contractorGroups: routine.contractorGroups.map(({ id }) => id),
        createDaysBefore: routine.createDaysBefore,
      };
